import { render } from "./IconClose.vue?vue&type=template&id=cc50513a"
import script from "./IconClose.vue?vue&type=script&lang=js"
export * from "./IconClose.vue?vue&type=script&lang=js"
script.render = render

export default script